import { computed, ref } from 'vue'
import { useAiConsentStore } from '@/state/useAiConsentStore'

export function useAiConsent() {
  const aiConsentStore = useAiConsentStore()
  const showConsentModal = ref(false)

  aiConsentStore.initialize()

  const needsConsent = computed(() => !aiConsentStore.hasConsent)

  const requestConsent = (): boolean => {
    if (needsConsent.value) {
      showConsentModal.value = true
      return false
    }
    return true
  }

  return {
    needsConsent,
    showConsentModal,
    requestConsent,
  }
}
